import React from "react";
import { products } from "@/mock";
import ProductCard from "@/components/site/ProductCard";
import { ArrowRight } from "lucide-react";

export default function BestSellers({ onAdd }) {
  return (
    <section id="shop" className="bg-white py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="text-[11px] tracking-[0.28em] text-[#c60d0d] font-bold uppercase mb-3">
              Shop the drop
            </div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tight text-black">
              BEST SELLERS
            </h2>
          </div>
          <a
            href="#collections"
            className="hidden md:inline-flex items-center gap-2 text-[12px] font-bold tracking-[0.18em] uppercase text-black/70 hover:text-[#c60d0d]"
          >
            View All <ArrowRight size={14} />
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} onAdd={onAdd} />
          ))}
        </div>
      </div>
    </section>
  );
}
